const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
	listgenerator: [],
	listgeneratorSize: 0,
};

function mockupReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_MOCKUP':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_LIST_MOCKUP':
			return {
				...state,
				list: action?.payload?.mockups || [],
				totalsize: action?.payload?.totalsize || 0
			};
		case 'ADMIN_LIST_MOCKUP_GENERATOR':
			return {
				...state,
				listgenerator: action?.payload?.mockupgenerators || [],
				listgeneratorSize: action?.payload?.totalsize_mockupgenerators || 0
			};
		default:
			return state;
	}
}

export default mockupReducer;
